export const isEmptyValue = (value: any): boolean => value === undefined || value === null || value === "";
